/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Section_Liable_Vehicle_TitleInputs */

const en_case_section_liable_vehicle_title = /** @type {(inputs: Case_Section_Liable_Vehicle_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liable vehicle`)
};

const pt_br2_case_section_liable_vehicle_title = /** @type {(inputs: Case_Section_Liable_Vehicle_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veículo terceiro`)
};

/**
* | output |
* | --- |
* | "Liable vehicle" |
*
* @param {Case_Section_Liable_Vehicle_TitleInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_section_liable_vehicle_title = /** @type {((inputs?: Case_Section_Liable_Vehicle_TitleInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Section_Liable_Vehicle_TitleInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_section_liable_vehicle_title(inputs)
	return pt_br2_case_section_liable_vehicle_title(inputs)
});